import React from 'react';
import { useLocation } from 'react-router-dom';
import "../../style/AppPages.css";
import "../../style/FormStyles.css";

const ConfirmationPage = () => {
    const location = useLocation();
    const message = location.state?.message || "No message provided";

    return (
        <div className="page-padding">
            <p class="account-text">{message}</p>
        </div>
    );
};

export default ConfirmationPage;
